import HeaderToolbarContent from './HeaderToolbar';
import { useGetTimeOnTaskReportMutation, useGetStudentTimeOnTaskReportMutation, useGetTimeOnTaskReportAllAssignmentMutation } from '../../features/authentication/reportApiSlice';
import { useGetAssignmentBasicMutation, useHasRetakeMutation } from '../../features/authentication/assignmentApislice';
import React, { useEffect, useState } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import html2pdf from 'html2pdf.js';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../features/authentication/authSlice';
import PropTypes from 'prop-types';
import { groupBy } from '../../utils/grouping';
import StudentWiseReport from './StudentWise';
import ClassWiseReport from './ClassWiseReport';
import { sumDurations } from '../../utils/SumTimeDuration';
import { SortUtils } from '../../utils/sorting';
import CustomToast from '../Toast';
import { DateFormatter } from '../../utils/DateFormatter';

const TimeOnTaskReport = ({ assignmentId , includeRetakes, isFromTeacherReport, classId, className, courseId, courseName, studentId, studentName, backButtonOnClick, startDate, endDate, studentToInclude, isLoginActivityReport}) => {
  const [getTimeOnTaskReport] = useGetTimeOnTaskReportMutation();
  const [getTimeOnTaskReportOfAllAssignment] = useGetTimeOnTaskReportAllAssignmentMutation();
  const [getStudentTimeOnTaskReport] = useGetStudentTimeOnTaskReportMutation();
  const [getAssignmentBasic] = useGetAssignmentBasicMutation();

  const [timeOnTaskReport, setTimeOnTaskReport] = React.useState(null);
  const [hasMultipleAssignment, setHasMultipleAssignment] = React.useState(false);
  const [studentTimeOnTaskReport, setStudentTimeOnTaskReport] = React.useState(null);
  const [selectedClassId, setSelectedClassId] = React.useState(classId);
  const [selectedClassName, setSelectedClassName] = React.useState('All Classes');
  const [assignmentBasic, setAssignmentBasic] = React.useState([]);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [isStudentReportDownloading, setIsStudentReportDownloading] = React.useState(false);
  const [checkHasRetake] = useHasRetakeMutation();

  const [sortColumn, setSortColumn] = useState('lName');
  const [sortDirection, setSortDirection] = useState('asc');
  const [openStudentReportModal, setOpenStudentReportModal] = useState(false);
  const [selectedStudentTotalTime, setSelectedStudentTotalTime] = useState(null);
  const [selectedStudentName, setSelectedStudentName] = useState(null);
  const [dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey] = useState(new Date().getTime().toString());
  const [previewIsRetake, setPreviewIsRetake] = useState(null);
  const [previewIsClassType, setPreviewIsClassType] = useState(null);
  const [assignmentName, setAssignmentName] = useState('');
  const [isDrillDownPage, setIsDrillDownPage] = useState(false);
  const ferpaEnabled = useSelector(selectFerpaState);

  async function loadReport(classId) {
    setTimeOnTaskReport(null);
    setSelectedClassId(classId);
    setIsDrillDownPage(false);
    if(assignmentId == -1)
    {
      loadAllAssignmentReport(classId);
    }
    else
    {
      loadSingleAssignmentReport(classId,assignmentId,false);
    }
  }

  async function loadSingleAssignmentReport(classId,assignmentId,isDrillDown)
  {
    setIsDrillDownPage(isDrillDown);
    const option = {
      assignmentId: assignmentId,
      classId: classId,
      includeRetakes: includeRetakes
    };
    var response = await getTimeOnTaskReport(option);
    if (response.error) {
      if(response.error.data?.error)
        CustomToast(response.error.data.error, 'error');
      else
        CustomToast('Report Generation Failed', 'error');

      setTimeOnTaskReport([]);
      if(isFromTeacherReport)
        backButtonOnClick();
      return;
    }
    
    const groupedReport = groupBy(response.data, 'assignmentName');
    setHasMultipleAssignment(Object.keys(groupedReport).length > 1);
    setTimeOnTaskReport(response.data);
    if(response.data.length>0)
      setAssignmentName(response.data[0].assignmentName);
  }

  async function loadAllAssignmentReport(classId) {
    setAssignmentName('All Assignment');
    if(isLoginActivityReport)
      setAssignmentBasic({courseName : 'All Courses'});
    const option = {
      classId: classId,
      includeRetakes: includeRetakes,
      startDate: DateFormatter.toShortDate2(startDate),
      endDate: DateFormatter.toShortDate2(endDate),
      courseId: courseId,
      studentId: studentId >0 ? studentId : -1,
      isLoginActivityReport : isLoginActivityReport
    };
    var response = await getTimeOnTaskReportOfAllAssignment(option);
    if (response.error) {
      if(response.error.data?.error)
        CustomToast(response.error.data.error, 'error');
      else
        CustomToast('Report Generation Failed', 'error');

      setTimeOnTaskReport([]);
      if(isFromTeacherReport)
        backButtonOnClick();
      return;
    }
    if(studentId>0)
    {
      setOpenStudentReportModal(true);
      setStudentTimeOnTaskReport(response.data);
      setSelectedStudentName(studentName);
      setPreviewIsRetake(includeRetakes);
      setPreviewIsClassType(true);
      var studentTotalTime = sumDurations(response.data.map(x=>x.totalTime));
      setSelectedStudentTotalTime(studentTotalTime);
    }
    else{
      setHasMultipleAssignment(true);
      setTimeOnTaskReport(response.data);
    }
  }

  async function loadAssignment(assignmentId) {
    const option = {
      assignmentId: assignmentId
    };
    var assignmentBasic = await getAssignmentBasic(option).unwrap();
    setAssignmentBasic(assignmentBasic);
    setAssignmentName(assignmentBasic?.name);
  }

  useEffect(() => {
    if(assignmentId !=-1)
    {
      loadAssignment(assignmentId);
    }
    if(studentToInclude == 2 && studentId>0 && assignmentId !=-1)
    {
      loadStudentReport();
    }else{
      loadReport(classId);
    }
  }, []);

  useEffect(() => {
    if(timeOnTaskReport)
      setDateTimeBasedUniqueKey(new Date().getTime().toString());
  }, [timeOnTaskReport]);

  const loadStudentReport= async ()=>{
    var isRetake = false;
    if(includeRetakes)
    {
      const response = await checkHasRetake(assignmentId).unwrap();
      isRetake = response.hasRetakes;
    }
    await openStudentReport(assignmentId,'',studentId,studentName, isRetake);
  };

  const handleClassChange = (classId) => {
    loadReport(classId);
  };

  const handlePrintPdf = async () => {
    setIsDownloading(true);
    const contentWrapper = document.getElementById('timeOnTask_pdf_Wrapper');
    const contentClone = contentWrapper.cloneNode(true);
    const buttonGroup = contentClone.querySelector('#buttonGroup');
    buttonGroup.classList.add('d-none');
    const dropDownContainer = contentClone.querySelector('#dropdown_container');
    dropDownContainer?.classList.add('d-none');
    const tables = document.getElementsByTagName('table');

    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    const options = {
      margin: 20,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'pt', format: hasMultipleAssignment? 'a3' : 'a4', orientation: 'landscape' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };

    await html2pdf().set(options).from(contentClone).save('TimeOnTaskReport.pdf');
    setIsDownloading(false);
  };

  const handleStudentPrintPdf = async () => {
    setIsStudentReportDownloading(true);
    const contentWrapper = document.getElementById('studenttimeOnTask_pdf_Wrapper');
    const contentClone = contentWrapper.cloneNode(true);
    const buttonGroup = contentClone.querySelector('#buttonGroup');
    buttonGroup.classList.add('d-none');
    const tables = document.getElementsByTagName('table');

    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    const options = {
      margin: 20,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };

    await html2pdf().set(options).from(contentClone).save(`${ferpaEnabled && selectedStudentName ? selectedStudentName : 'Student'}_TimeOnTaskReport.pdf`);
    setIsStudentReportDownloading(false);
  };

  const handleFerpaChange = async (e) => {
    if ((sortColumn === 'lName' || sortColumn === 'fName')) {
      if (!e.target.checked) {
        const shuffledItems = [...timeOnTaskReport].sort(() => Math.random() - 0.5);
        setTimeOnTaskReport(shuffledItems);
      } else {
        loadReport(selectedClassId);
      }
    }
  };

  const handleSort = (column) => {
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);

    if (column == 'totalTime') {
      sortDuration(column, direction);
    }
    else if (column == 'startedOn' || column == 'completedOn') {
      sortDate(column, direction);
    } else {
      sortString(column, direction);
    }
  };

  const openStudentReport = async (assignmentId, assignmentName, studentId, studentName, isRetake, isDrillDown) => {
    if(isLoginActivityReport)
      loadAssignment(assignmentId);
    
    setIsDrillDownPage(isDrillDown);
    setOpenStudentReportModal(true);
    setStudentTimeOnTaskReport(null);
    setSelectedStudentName(studentName);
    setPreviewIsRetake(isRetake);
    setPreviewIsClassType(isRetake);
    if(assignmentName)
      setAssignmentName(assignmentName);

    if(isRetake)
    {
      const option = {
        assignmentId: assignmentId,
        classId: selectedClassId,
        includeRetakes: includeRetakes,
        studentId: studentId
      };
      var report = await getTimeOnTaskReport(option).unwrap();
      setStudentTimeOnTaskReport(report);
      var totalTime = sumDurations(report.map(x=>x.totalTime));
      setSelectedStudentTotalTime(totalTime);

    }else{
      const option = {
        assignmentId: assignmentId,
        studentId: studentId,
        includeRetakes: includeRetakes
      };
      var StudentReport = await getStudentTimeOnTaskReport(option).unwrap();
      setStudentTimeOnTaskReport(StudentReport);
      var studentTotalTime = sumDurations(StudentReport.map(x=>x.totalTime));
      setSelectedStudentTotalTime(studentTotalTime);
    }
  };

  const closeStudentReport = () => {
    setOpenStudentReportModal(false);
    setStudentTimeOnTaskReport(null);
    setSelectedStudentName(null);
    setSelectedStudentTotalTime(null);
    setPreviewIsRetake(null);
    setPreviewIsClassType(null);
  };

  const renderSortIcons = (column) => {
    return (SortUtils.renderSortIcons(sortDirection, sortColumn, column));
  };

  const sortString = (column, direction) => {
    var sortedValue = [...timeOnTaskReport].sort((a, b) => {
      return direction === 'asc' ? a[column].localeCompare(b[column]) : b[column].localeCompare(a[column]);
    });

    setTimeOnTaskReport(sortedValue);
  };

  const sortDate = (column, direction) => {
    var sortedValue = [...timeOnTaskReport].sort((a, b) => {
      const dateA = new Date(a[column]);
      const dateB = new Date(b[column]);
      return direction === 'asc' ? dateA - dateB : dateB - dateA;
    });
    setTimeOnTaskReport(sortedValue);
  };

  const sortDuration = (column, direction) => {
    var sortedValue = [...timeOnTaskReport].sort((a, b) => {
      const durationA = convertToSeconds(a[column]);
      const durationB = convertToSeconds(b[column]);
      return direction === 'asc' ? durationA - durationB : durationB - durationA;
    });
    setTimeOnTaskReport(sortedValue);
  };

  const convertToSeconds = (duration) => {
    const [hours, minutes, seconds] = duration.split(':');
    return parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
  };

  useEffect(() => {
    handleFerpaChange();
  }, [ferpaEnabled]);

  return (
    <>
      {!openStudentReportModal && <div className="white-card" id='timeOnTask_pdf_Wrapper'>
        <HeaderToolbarContent
          reportTitle='Time On Task Tracking Report'
          setSelectedClassName={setSelectedClassName}
          onClassChange={x => { handleClassChange(x); }}
          printHandler={handlePrintPdf}
          isExporting={false}
          isDownloading={isDownloading}
          hideClassDropdown={isFromTeacherReport}
          backButtonOnClick={()=> {isFromTeacherReport? (isDrillDownPage? loadReport(selectedClassId):backButtonOnClick()):backButtonOnClick();}}
        />

        {timeOnTaskReport && <div className="student_response_details">
          <div className="d-flex justify-content-between">
            <div className="student_response_details_left">
              <p>
                Class: <strong>{ studentToInclude ==0 ? 'All Classes' : (isFromTeacherReport?className:selectedClassName)}</strong>
              </p>
              <p>
                Assignment: <strong>{assignmentName}</strong>
              </p>
            </div>
            <div className="student_response_details_right">
              <p>
                Course: <strong>{courseName? courseName : assignmentBasic?.courseName}</strong>
              </p>
              <p>
                Total Students: <strong>{timeOnTaskReport?.length}</strong>
              </p>
            </div>
          </div>
        </div>
        }

        <div className="mt-5" >
          <ClassWiseReport 
            key={dateTimeBasedUniqueKey}
            classReportData={timeOnTaskReport}
            hasMultipleAssignment={hasMultipleAssignment}
            openStudentReport={openStudentReport}
            selectedClassId ={selectedClassId}
            hideClassColumn={studentToInclude==0}
            handleSort={handleSort}
            renderSortIcons={renderSortIcons}
            ferpaEnabled={ferpaEnabled}
            assignmentCanDrillDown={assignmentId == -1 && !includeRetakes}
            drillDownOnClick={loadSingleAssignmentReport}
          />
        </div>

      </div>
      }


      {openStudentReportModal && <div className="white-card" id='studenttimeOnTask_pdf_Wrapper'>
        <HeaderToolbarContent
          reportTitle='Time On Task Tracking Report'
          setSelectedClassName={setSelectedClassName}
          hideClassDropdown={true}
          printHandler={handleStudentPrintPdf}
          isDownloading={isStudentReportDownloading}
          backButtonOnClick={()=>{isFromTeacherReport && studentToInclude ==2 && (previewIsClassType || (studentId >0 && !isDrillDownPage)) ? backButtonOnClick(): (isDrillDownPage?loadReport(selectedClassId):closeStudentReport());}}
        />

        {studentTimeOnTaskReport && <div className="student_response_details">
          <div className="d-flex justify-content-between">
            <div className="student_response_details_left">
              <p>
                Course: <strong>{courseName? courseName : assignmentBasic?.courseName}</strong>
              </p>
              <p>
                Assignment: <strong>{assignmentName}</strong>
              </p>
            </div>
            <div className="student_response_details_right">
              <p>
                Student: <strong>{ferpaEnabled ? selectedStudentName : <i>Name hidden</i>}</strong>
              </p>
              <p>
                Total Time On Assignment: <strong>{selectedStudentTotalTime}</strong>  <span className='fs-7 fw-normal'>(HH:MM:SS)</span>
              </p>
            </div>
          </div>
        </div>
        }

        <div className='mt-3'>
          {previewIsClassType == true &&
            <ClassWiseReport 
              key={dateTimeBasedUniqueKey}
              classReportData={studentTimeOnTaskReport}
              hasMultipleAssignment={true}
              openStudentReport={openStudentReport}
              selectedClassId ={selectedClassId}            
              renderSortIcons={()=>{}}
              ferpaEnabled={ferpaEnabled}
              isSingleStudent={true}
              assignmentCanDrillDown={!previewIsRetake}
              drillDownOnClick={openStudentReport}
            />      
          }
          {!previewIsClassType && <StudentWiseReport studentReportData={studentTimeOnTaskReport} />}
        </div>
      </div>
      }
    </>

  );
};

TimeOnTaskReport.propTypes = {
  assignmentId: PropTypes.number.isRequired,
  includeRetakes: PropTypes.bool.isRequired,
  isFromTeacherReport: PropTypes.bool.isRequired,
  classId: PropTypes.number.isRequired,
  className: PropTypes.string,
  courseId: PropTypes.number,
  courseName: PropTypes.string,
  studentId: PropTypes.number,
  studentName: PropTypes.string,
  backButtonOnClick: PropTypes.func,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  studentToInclude: PropTypes.number,
  isLoginActivityReport: PropTypes.bool
};

export default TimeOnTaskReport;